import React, { useState } from "react";
import { Smile } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

const EMOJIS = ["🔥", "❤️", "😂", "👀", "🌈", "💯", "✨", "🥲"];

/**
 * Reaction strip + add-button for a message.
 * Props: message {id, reactions:{emoji:[user_ids]}}, meId, onReact(emoji)
 */
export default function MessageReactions({ message, meId, onReact, mine }) {
  const [open, setOpen] = useState(false);
  const reactions = message.reactions || {};
  const entries = Object.entries(reactions).filter(([, ids]) => (ids || []).length > 0);

  const pick = (e) => {
    onReact?.(e);
    setOpen(false);
  };

  return (
    <div
      className={`mt-1 flex flex-wrap items-center gap-1 ${mine ? "justify-end" : "justify-start"}`}
      data-testid={`reactions-${message.id}`}
    >
      {entries.map(([emoji, ids]) => {
        const reactedByMe = ids.includes(meId);
        return (
          <button
            key={emoji}
            onClick={() => onReact?.(emoji)}
            data-testid={`reaction-${message.id}-${emoji}`}
            className={`px-2 h-6 rounded-full text-xs flex items-center gap-1 border transition ${
              reactedByMe
                ? "bg-fuchsia-500/15 border-fuchsia-400/50 text-fuchsia-200"
                : "bg-white/5 border-white/10 text-zinc-300 hover:border-white/20"
            }`}
          >
            <span className="text-sm leading-none">{emoji}</span>
            <span className="font-semibold">{ids.length}</span>
          </button>
        );
      })}
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button
            data-testid={`add-reaction-${message.id}`}
            className="opacity-60 md:opacity-0 md:group-hover:opacity-100 transition-opacity h-6 w-6 rounded-full bg-white/5 border border-white/10 text-zinc-400 hover:text-white inline-flex items-center justify-center"
            aria-label="Add reaction"
          >
            <Smile className="w-3 h-3" />
          </button>
        </PopoverTrigger>
        <PopoverContent
          align="start"
          sideOffset={6}
          className="w-auto p-1.5 bg-[#121215] border-white/10"
        >
          <div className="flex gap-0.5">
            {EMOJIS.map((e) => (
              <button
                key={e}
                onClick={() => pick(e)}
                data-testid={`pick-reaction-${e}`}
                className="w-9 h-9 rounded-md hover:bg-white/10 transition text-xl"
              >
                {e}
              </button>
            ))}
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}
